<template>
  <div class="diy-banner">
    <van-swipe
    >
      <!-- :autoplay="autoplay"
      :class="'banner-box swiper-box dot-'itemStyle.btnShape"
      duration="{{ duration }}"
      circular="{{ true }}"
      indicator-dots="{{ indicatorDots }}"
      interval="{{ params.interval }}"
      indicator-color="{{ itemStyle.btnColor }}"
      indicator-active-color="#000"
      bindchange="_bindChange"
      data-item-key="{{ itemIndex }}"
      style="height: {{ imgHeights[imgCurrent] }}rpx" -->
      <van-swipe-item>1</van-swipe-item>
      <van-swipe-item>2</van-swipe-item>
      <van-swipe-item>3</van-swipe-item>
      <van-swipe-item>4</van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
  data() {
    return {
      indicatorDots: true, // 是否显示面板指示点
      autoplay: true, // 是否自动切换
      duration: 800, // 滑动动画时长
      imgHeights: [], // 图片的高度
      imgCurrent: 0 // 当前banne所在滑块指针
    };
  },
  methods:{
      
  }
};
</script>

<style lang="less" scoped>
/* banner轮播 */

.diy-banner {
  position: relative;
}

.diy-banner .slide-image {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: block;
}

/* 顶部置灰 */

.diy-banner .linear {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3.4rem;
  background: linear-gradient(#111, transparent);
  opacity: 0.6;
  z-index: 9;
}

.swiper-box .wx-swiper-dots.wx-swiper-dots-horizontal {
  margin-bottom: 2rpx;
}

/* banner组件按钮 */

.swiper-box .wx-swiper-dot {
  height: 10px;
  width: 10px;
}

.swiper-box.dot-rectangle .wx-swiper-dot {
  width: 15px;
  border-radius: unset;
}

.swiper-box.dot-square .wx-swiper-dot {
  border-radius: unset;
}

</style>